import { Rgb } from './parseHexColor';

/** Relative Leuchtdichte nach WCAG 2.1. */
export const relativeLuminance = ([r, g, b]: Rgb): number => {
  const [rs, gs, bs] = [r, g, b].map((value) => {
    const channel = value / 255;
    return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
};

/** Kontrastverhältnis zweier Farben nach WCAG 2.1 (1:1 bis 21:1). */
export const contrastRatio = (a: Rgb, b: Rgb): number => {
  const [first, second] = [relativeLuminance(a), relativeLuminance(b)];
  return (Math.max(first, second) + 0.05) / (Math.min(first, second) + 0.05);
};

export const WHITE_RGB: Rgb = [0xff, 0xff, 0xff];

/**
 * `--color-grey-light` aus `core/styles/global.scss`. Dient an mehreren Stellen als
 * Hintergrund-Fallback einer Karte ohne eigene Farbe und muss zum Rechnen als Hex vorliegen.
 */
export const GREY_LIGHT_HEX = '#8e949f';
